import {
  tooltip_styles_default
} from "./chunk.LJ4ZP3CB.js";
import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  o,
  r
} from "./chunk.4JTBA2KG.js";

// src/components/tooltip/tooltip.styles.ts
function createTooltipVariant(name, color) {
  return o(` .tooltip--${name} .tooltip__content { background-color: var(${color}); color: var(--sl-color-neutral-0); } .tooltip--${name} .tooltip__arrow { background-color: var(${color}); } `);
}
var tooltip_styles_default2 = r` ${tooltip_styles_default} ${component_mobile_styles_default} ${createTooltipVariant("primary", "--sl-color-primary-600")} ${createTooltipVariant("secondary", "--sl-color-secondary-600")} ${createTooltipVariant("tertiary", "--sl-color-tertiary-600")} ${createTooltipVariant("success", "--sl-color-success-600")} ${createTooltipVariant("neutral", "--sl-color-neutral-600")} ${createTooltipVariant("warning", "--sl-color-warning-600")} ${createTooltipVariant("danger", "--sl-color-danger-600")} .tooltip { text-align: center; } `;

export {
  tooltip_styles_default2 as tooltip_styles_default
};
